namespace JupitersChoice {
    export class ShowWinsCmd {

        @inject('AutoplayManager') _autoplayManager: Sapphire.AutoplayManager;
        @inject('CurrencyFormatter') _currencyFormatter: Sapphire.CurrencyFormatter;
        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('FreeGameModel') _freeGameModel: FreeGameModel;
        @inject('FreeSpinsPromoModel') _freeSpinsPromoModel: Sapphire.FreeSpinsPromoModel;
        @inject('GameStage') _gameStage: Sapphire.GameStage;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        static currentDisplayIdx = 0;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const reels = this._componentManager.get('Reels');
            const paylineDisplay = this._componentManager.get('PaylineDisplay');
            const balanceMeter = this._componentManager.get('BalanceMeter');
            const winMeter = this._componentManager.get('WinMeter');
            const winTally = this._componentManager.get('TotalWinText');
            const lineWinTally = this._componentManager.get('LineWinText');
            const winnings = this._stateModel.currentSubgame === 'BaseGame' ?
                response.winnings : response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1].winnings;
            const symbols = this._stateModel.currentSubgame === 'BaseGame' ?
                response.symbols : response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1].symbols;
            var wildPositions = [];

            var winAmountFromCurrentSpin = this._responseHelper.getWinAmountFromCurrentSpin(winnings);
            // Win meter display
            // - base game, should show the whole win amount (response.win)
            // - free game, should the running total of free game wins (deduct any base game winnings)

            // Win tally display
            // - base game, should the win amount from this spin
            // - free game, should the win amount from this spin
            if (this._stateModel.currentSubgame === 'BaseGame') {
                //winTally.addChild(ThreeDTextHelper.getNumberAsFont(this._currencyFormatter.format(winAmountFromCurrentSpin),80));
                winTally.setText(this._currencyFormatter.format(winAmountFromCurrentSpin));

                // if player is returning from free game, win meter needs to show combined win from free game + any deferred wins
                if (this._freeGameModel.isReturningFrom) {
                    winAmountFromCurrentSpin = response.win;
                    this._freeGameModel.isReturningFrom = false;
                }

                winMeter.setValue(this._currencyFormatter.format(winAmountFromCurrentSpin));

                if (this._freeSpinsPromoModel.isInProgress) {
                    winMeter.setValue(this._currencyFormatter.format(response.stats.freespins.win));
                }
            } else {
                let currentFreeSpinInfo = response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1];
                let totalFreeGameWin = currentFreeSpinInfo.runningTotal + winAmountFromCurrentSpin;

                // check for base game win, deduct base game wins
                if (this._responseHelper.hasBaseGameWinnings(response.winnings)) {
                    let baseGameWinAmount = this._responseHelper.getWinAmountFromCurrentSpin(response.winnings);
                    totalFreeGameWin -= baseGameWinAmount;
                }

                // add on any previous wins in base game from promo spins
                if (this._freeSpinsPromoModel.isInProgress) {
                    totalFreeGameWin += (response.stats.freespins.win - response.win);
                }

                winMeter.setValue(this._currencyFormatter.format(totalFreeGameWin));

                //winTally.addChild(ThreeDTextHelper.getNumberAsFont(this._currencyFormatter.format(winAmountFromCurrentSpin),80));
                winTally.setText(this._currencyFormatter.format(winAmountFromCurrentSpin));
            }

            if (this._stateModel.currentSubgame === 'BaseGame' && !this._freeSpinsPromoModel.isInProgress) {
                balanceMeter.setValue(this._currencyFormatter.format(response.stats.b));
            }

            this._layerManager.setVisibility('WinPopup', true);
            if (winnings.length > 1){
                winTally.show();

                TweenMax.delayedCall(1, () => {
                    winTally.hide();
                });
            }

            if (winnings.length > 0) {
                this._soundManager.play('win_small_01');
            }

            // Find position of wilds (if any) - adding +1 to indices here to match winnings response data from API
            symbols.forEach((column, columnIdx) => {
                column.forEach((frameName, rowIdx) => {
                    if (frameName === 'WR') {
                        wildPositions.push({
                            x: columnIdx + 1,
                            y: rowIdx + 1
                        })
                    }
                });
            });

            var asset = new PIXI.Sprite(this._assetCache.getTexture('PaylineDisplay', 'winLightning', 'cut.png'));
            var asset2 = new PIXI.Sprite(this._assetCache.getTexture('PaylineDisplay', 'winLightning', 'cut.png'));
            var isWebGL: boolean = this._gameStage.isWebGL;

            // loop around positions
            var coords = [];
            var prevX;
            var row = [];
            var baseX = 121; // 365;
            var textBaseX = 220;
            var baseY = 133;
            var xDiff = 235; //238
            var yDiff = 205; //221
            var lightningStrikes: Sapphire.Lightning[] = [];
            var currIdx = 0;
            var textObjs = [];

            if (winnings.length > 0) {
                winnings.forEach(winning => {
                    coords = [];
                    winning[3].forEach(winningPosition => {
                        if (winningPosition.x === prevX) {
                            row[1].unshift(baseY + (winningPosition.y * yDiff));
                        } else {
                            row = [];
                            row.push(baseX + (winningPosition.x * xDiff));
                            row.push([baseY + (winningPosition.y * yDiff)]);
                            coords.push(row);
                        }

                        prevX = winningPosition.x;
                    });

                    var lightning = new Sapphire.Lightning(asset,asset2,isWebGL);
                    var options: Object = {
                        ySpread: 100
                    };

                    lightning.generate(coords, options);
                    lightningStrikes.push(lightning);

                    var maxX = 0;
                    for(var i: number=0;i<winning[3].length;++i){
                      if(winning[3][i].x > maxX){
                        maxX = winning[3][i].x;
                      }
                    }
                    var midX = (maxX-1) / 2;
                    var floorX = Math.floor(midX);
                    var ceilX = Math.ceil(midX);
                    var minYBefore = 100, minYAfter = 100;
                    var maxYBefore = 0, maxYAfter = 0;
                    for(var i: number=0;i<winning[3].length;++i){
                        if(winning[3][i].x == floorX+1){
                          if(winning[3][i].y < minYBefore){
                            minYBefore = winning[3][i].y;
                          }
                          if(winning[3][i].y > maxYBefore){
                            maxYBefore = winning[3][i].y;
                          }
                        }
                        if(winning[3][i].x == ceilX+1){
                            if(winning[3][i].y < minYAfter){
                                minYAfter = winning[3][i].y;
                            }
                            if(winning[3][i].y > maxYAfter){
                                maxYAfter = winning[3][i].y;
                            }
                        }
                      }
                    var yBefore = (minYBefore+maxYBefore)/2;
                    var yAfter = (minYAfter+maxYAfter)/2
                    
                    var midPointX = midX+1;
                    var midPointY = floorX == midX ? yBefore : (yBefore + yAfter)/2;

                    //var textObj = ThreeDTextHelper.getNumberAsFont(this._currencyFormatter.format(winning[2]),60);
                    

                    textObjs.push([winning[2],textBaseX + (midPointX * xDiff),baseY + (midPointY * yDiff)]);
                });

                this._layerManager.setVisibility('PaylineDisplay', true);
                this._eventManager.publish('onShowSkipPaylinesButton');

                var cycler = this._componentManager.get('Cycler');

                var firstLoop: boolean = true;

                cycler.onCycle = () => {
                    /*while (this._componentManager.get('PaylineDisplay').children[0]) {
                        paylineDisplay.removeChild(this._componentManager.get('PaylineDisplay').children[0])
                    }*/
                    paylineDisplay.clear();

                    let currentWinning = winnings[currIdx];

                    let payline = currentWinning[3].map(({x, y}) => ({
                        x,
                        y,
                        symbol: `${currentWinning[4]}.png`,
                        replaceWith: {
                        symbolFrame: 'WR.png',
                        positions: wildPositions
                        }
                    }));
            
                    reels.resetOpacity();
                    reels.setOpacityByPositions(currentWinning[3], 0);

                    paylineDisplay.sprite2Mask = lightningStrikes[currIdx].maskSprite;
                    paylineDisplay.show(payline, this._assetCache);                    

                    paylineDisplay.addChild(lightningStrikes[currIdx]);

                    lineWinTally.setText(this._currencyFormatter.format(textObjs[currIdx][0]));
                    lineWinTally.setPosition(textObjs[currIdx][1],textObjs[currIdx][2]);
                    lineWinTally.show();

                    if(firstLoop && winnings[currIdx][4].substr(0,1) == 'H'){
                        //winning for high
                        this._soundManager.play('win_'+winnings[currIdx][4]);
                    }

                    if(firstLoop){
                        this._soundManager.play('payline_highlight');
                    }
                    lightningStrikes[currIdx].play(() => {
                        if (++currIdx >= lightningStrikes.length) {
                            firstLoop = false;
                            currIdx = 0;
    
                            // in base game autoplay, rotate around pays once and then move on
                            if (this._stateModel.currentSubgame === 'BaseGame') {
                                this._eventManager.publish('onShowWinsComplete');
                            }
    
                            // in free game, rotate around pays once and then move on
                            if (this._stateModel.currentSubgame === 'FreeGame') {
                                this._eventManager.publish('onShowFreeGameWinsComplete');
                            }
                        }
                        cycler.next();
                    });
                };

                cycler.onKill = () => {
                    lineWinTally.hide();
                    if(typeof lightningStrikes[currIdx] != "undefined"){
                        lightningStrikes[currIdx].stop();
                    }
                    paylineDisplay.clear();
                    if(lightningStrikes){
                        for(var i=0; i<lightningStrikes.length;++i){
                            lightningStrikes[i].reset();
                            lightningStrikes[i] = null;
                        }
                        lightningStrikes = [];
                    }
                    
                    reels.resetOpacity();
                    this._layerManager.setVisibility('WinPopup', false);
                };

                cycler.start(winnings.length == 1 ? 0 : null);
            }else{
                if (this._stateModel.currentSubgame === 'BaseGame') {
                    this._eventManager.publish('onShowWinsComplete');
                }
            }
        }
    }
}
